import { render, staticRenderFns } from "./AffiliationEdit.vue?vue&type=template&id=728ebc6b&"
import script from "./AffiliationEdit.vue?vue&type=script&lang=js&"
export * from "./AffiliationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports